import Face2OutlinedIcon from '@mui/icons-material/Face2Outlined';

/**
 * Rosácea: grau de cada subtipo presente.
 * Referência clínica: classificação em quatro subtipos do comitê da National
 * Rosacea Society (Wilkin et al., J Am Acad Dermatol 2002;46:584-7) e a
 * graduação proposta pelo mesmo comitê (Wilkin et al., J Am Acad Dermatol
 * 2004;50:907-12). A classificação por fenótipos de 2017 (Gallo et al.) existe,
 * mas os subtipos seguem como linguagem do dia a dia. Textos nossos.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/rosacea.php.
 */
const rosacea = {
  key: 'rosacea',
  name: 'Rosácea: subtipo e grau',
  description: 'Grau de cada subtipo presente: leve, moderado ou grave',
  details: 'Registra quais subtipos de rosácea o paciente apresenta (eritematotelangiectásica, papulopustulosa, fimatosa e ocular) e o grau de cada um. Os subtipos podem coexistir e mudar de intensidade com as crises e o tratamento. A classificação mais recente, de 2017, descreve a rosácea por fenótipos, mas os subtipos continuam sendo a linguagem do dia a dia da clínica. Marque só os subtipos presentes: o card mostra o registro da última consulta e a aba Saúde guarda a evolução.',
  kind: 'regions',
  icon: Face2OutlinedIcon,
  accent: 'pink',
  regions: [
    { key: 'erythematotelangiectatic', label: 'Eritematotelangiectásica', image: 'rosacea-1.png' },
    { key: 'papulopustular', label: 'Papulopustulosa', image: 'rosacea-2.png' },
    { key: 'phymatous', label: 'Fimatosa', image: 'rosacea-3.png' },
    { key: 'ocular', label: 'Ocular', image: 'rosacea-4.png' },
  ],
  columns: [
    {
      key: 'grade',
      label: 'Grau',
      options: [
        { value: 'mild', label: 'Leve' },
        { value: 'moderate', label: 'Moderado' },
        { value: 'severe', label: 'Grave' },
      ],
    },
  ],
};

export default rosacea;
